export const prepareHTTPConfig = (req): RequestInit => {
  return {
    method: req && req.method ? req.method : 'GET',
    headers: {
      'content-type': 'application/json;charset=utf-8',
      ...(req && req.headers && req.headers.authorization
        ? { authorization: req.headers.authorization }
        : {}),
    },
    ...(req && req.body && Object.keys(req.body).length ? { body: req.body } : {}),
  };
};
